import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { of, from, Observable } from 'rxjs';
import { debounceTime, switchMap, map,catchError } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AsyncValidatorFn, AbstractControl, ValidationErrors, FormControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { ProductInfo } from '../model/ProductInfo.model';
import { UomInfo } from '../model/UomInfo.model';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { AssetCategoryInfoInfo } from '../model/AssetCategoryInfoInfo.model';
import { AssetTypeInfo } from '../model/AssetTypeInfo.model';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-product-management',
  templateUrl: './product-management.component.html',
  styleUrls: ['./product-management.component.css']
})
export class ProductManagementComponent implements OnInit {
  form: FormGroup;

  baseurl: string;
  loading: boolean = false;
  isOnUpdateProduct: boolean = false;
  IsProduct: boolean = true;

  _EmpCode: string = '';
  _RoleCode: string = '';
  detailmodal: string = '';

  txtSearchProductCode: string = '';
  txtSearchProductName: string = '';

  ProductList: ProductInfo[] = [];
  ProductCheckDupList: ProductInfo[] = [];

  UomList: UomInfo[] = [];
  AssetCategoryList: AssetCategoryInfoInfo[] = [];
  AssetTypeList: AssetTypeInfo[] = [];

  formattedPrice: string = '';
  formattedBV: string = '';
  formattedVat: string = '';
  hidProductID: number;

  private subscriptions: Subscription = new Subscription();
  public currentPageNumberPrduct: number = 1;
  public totalPagesProduct: number
  totalItems: number = 0

  @ViewChild('chkAllProduct', { static: false }) chkAllProduct: ElementRef;
  @ViewChild('chkAllProduct', { static: false }) chchkAllProductkAllContact: ElementRef;

  ActiveList = [
    { ActiveCode: 'Y', ActiveName: 'Yes' },
    { ActiveCode: 'N', ActiveName: 'No' }
  ];

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private TokenService: TokenService, private GlobalService: GlobalService) { 
    this.baseurl = environment.base_api;
  }

  async ngOnInit(): Promise<void> {
    this._EmpCode = localStorage.getItem("EmpCode");
    this._RoleCode = localStorage.getItem("EmpRoleCode");

    this.form = this.formBuilder.group({
      txtProductCode: ['', {
      validators: [Validators.required],
      asyncValidators: [this.duplicateProductCodeValidator()],
      updateOn: 'blur'
    }],
      ProductName: [null, Validators.required],
      ProductUOM: [null, Validators.required],
      ProductPrice: [null, Validators.required],
      ProductBV: [null],
      ProductVat: [null],
      ProductUseVatFlag: [null, Validators.required],
      ProductCategory: [null],
      ProductType: [null],
      ProductLicensePlate: [null],
      ProductChassisNo: [null],
      ProductSerialNo: [null],
      ProductDescription: [null]
    });

    await this.LoadProductList();
    await this.LoadUomList();
    await this.LoadAssetCategoryList();

    const categoryChangeSubscription = this.form.get('ProductCategory')?.valueChanges.subscribe(async (selectedCategoryCode: string | null) => {
      console.log('ProductCategory changed to:', selectedCategoryCode);

      // 1. โหลด AssetType List ใหม่ตาม ProductCategory ที่เลือก
      await this.LoadAssetTypeList(selectedCategoryCode);

      // 2. ถ้าอยู่ในโหมดแก้ไข และมีข้อมูล Product ที่กำลังแก้ไข
      // Next Task
    });

    if (categoryChangeSubscription) {
      this.subscriptions.add(categoryChangeSubscription);
    }
  }

  async LoadProductList(bySearch: string | null = null) {
    this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if (bySearch === "Y") {
        this.currentPageNumberPrduct = 1;
      }

      const objectjson = {
        ProductCode: this.checkUndefinedString(this.txtSearchProductCode?.trim()),
        ProductName: this.checkUndefinedString(this.txtSearchProductName?.trim()),
        rowFetch: environment.PageSize,
        rowOFFSet: ((this.currentPageNumberPrduct - 1) < 0 ? 0 : (this.currentPageNumberPrduct - 1)) * environment.PageSize
      };

      const response = await this.httpClient.post<any>(this.baseurl + "Product/GetProductList", 
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.ProductList = response;
      this.totalItems = this.ProductList.length;

      if (this.ProductList.length <= 0) {
        this.currentPageNumberPrduct = 0;
      } else {
        if (this.currentPageNumberPrduct == 0) this.currentPageNumberPrduct = 1;
        this.totalItems = Number(this.ProductList[0].itemTotal);
      }

      this.totalPagesProduct = Math.ceil(this.totalItems / environment.PageSize);
    } catch (error) {
      console.error('Error loading product:', error);
      alert('An error occurred while loading product data. Please try again.');
    } finally {
      this.loading = false;
    }
  }

  OnLoadProductList(target = null) {
    if (target != null) {
      this.currentPageNumberPrduct = target.currentPageNumber;
      this.totalPagesProduct = target.totalPages;
    }

    this.LoadProductList();
  }

  async LoadUomList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {};

      const response = await this.httpClient.post<any>(this.baseurl + "Uom/GetUom",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.UomList = response;
      //console.log('UomList', this.UomList);      
      } catch (error) {
        console.error('Error loading product:', error);
        alert('An error occurred while loading product data. Please try again.');
      } finally {
    }
  }

  async LoadAssetCategoryList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {};

      const response = await this.httpClient.post<AssetCategoryInfoInfo[]>(this.baseurl + "AssetType/GetAssetCategory",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.AssetCategoryList = response;
      //console.log('AssetCategoryList', this.AssetCategoryList);      
      } catch (error) {
        console.error('Error loading asset category:', error);
        alert('An error occurred while loading asset category data. Please try again.');
      } finally {
    }
  }

  async LoadAssetTypeList(assetCategoryCode: string | null) {
    try {
      this.AssetTypeList = [];
      this.form.get('ProductType')?.patchValue(null);

      if (!assetCategoryCode) {
        return; // ไม่ต้องโหลดถ้าไม่มี category code
      }

      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        AssetCategoryCode: assetCategoryCode
      };

      const response = await this.httpClient.post<AssetTypeInfo[]>(this.baseurl + "AssetType/GetAssetType",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.AssetTypeList = response;
      //console.log('AssetTypeList', this.AssetTypeList);      
      } catch (error) {
        console.error('Error loading asset type:', error);
        alert('An error occurred while loading asset type data. Please try again.');
      } finally {
    }
  }

  btnClick_SearchProductList() {
    this.LoadProductList("Y");
  }

  ClearSearchProduct() {
   this.txtSearchProductCode = ""; 
   this.txtSearchProductName = "";
   this.LoadProductList("Y");
  }

  btnClick_onCreateProduct() {
    this.isOnUpdateProduct = false;
    this.form.reset();

    //this.form.get('ProductUOM')?.patchValue(this.UomList[0].UomCode);
    $('#ModalAddEditProduct').modal('show');
  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  // async btnClick_submitInsertProduct0() {
  //   this.loading = true;
  //   if (!this.form.valid) {
  //       this.markFormGroupTouched(this.form);
  //       console.warn('form not valid');
  //       return;
  //   }

  //   let auth_token: string | null = null;
  //   try {
  //       auth_token = await this.TokenService.RefreshToken();
  //   } catch (tokenError) {
  //       console.error('Cannot get Refresh Token:', tokenError);
  //       return;
  //   }

  //   if (!auth_token) {
  //       console.error('Authentication Token not found');
  //       return;
  //   }

  //   const httpOptions = {
  //       headers: new HttpHeaders({
  //           'Content-Type': 'application/json',
  //           'Authorization': `Bearer ${auth_token}`
  //       })
  //   };

  //   var objectjson: any = {};
  //   objectjson['ProductCode'] = this.form.get('txtProductCode')?.value;
  //   objectjson['ProductName'] = this.form.get('ProductName')?.value;
  //   objectjson['ProductUOM'] = this.form.get('ProductUOM')?.value;
  //   objectjson['ProductPrice'] = this.form.get('ProductPrice')?.value;
  //   objectjson['ProductBV'] = this.form.get('ProductBV')?.value;
  //   objectjson['ProductVat'] = this.form.get('ProductVat')?.value;
  //   objectjson['ProductUseVatFlag'] = this.form.get('ProductUseVatFlag')?.value;
  //   objectjson['ProductCategory'] = this.form.get('ProductCategory')?.value;
  //   objectjson['ProductType'] = this.form.get('ProductType')?.value;
  //   objectjson['ProductLicensePlate'] = this.form.get('ProductLicensePlate')?.value;
  //   objectjson['ProductChassisNo'] = this.form.get('ProductChassisNo')?.value;
  //   objectjson['ProductSerialNo'] = this.form.get('ProductSerialNo')?.value;
  //   objectjson['ProductDescription'] = this.form.get('ProductDescription')?.value;
  //   objectjson['ProductCreateBy'] = this.checkUndefinedString(this._EmpCode);

  //   let strjson = JSON.stringify(objectjson);
  //   //console.log('Payload InsertProduct:', strjson); // Log Payload

  //   try {
  //       await this.httpClient.post<ProductInfo[]>(this.baseurl + "Product/InsertProduct", strjson, httpOptions).toPromise();

  //       //console.log('Call Insert Product API Success.');

  //       $('#ModalAddEditProduct').modal('hide');
  //       $('#ModalProductInsertUpdateComplete').modal('show');

  //       setTimeout(async () => {
  //           await this.LoadProductList("Y");
  //       }, 100);

  //   } catch (apiError) {
  //       console.error('Call Insert Product API UnSuccess:', apiError);
  //   } finally {
  //     this.loading = false;
  //   }
  // }

  async btnClick_submitInsertProduct() {
  this.loading = true;
  
  // Wait async validation work finished
  await this.waitForAsyncValidation();
  
  if (!this.form.valid) {
    this.markFormGroupTouched(this.form);
    console.warn('Form not valid');
    this.loading = false;
    return;
  }

  // Check duplicate before submit
  const productCode = this.form.get('txtProductCode')?.value;
  if (productCode) {
    try {
      const duplicates = await this.checkDuplicateProductCode(productCode);
      if (duplicates && duplicates.length > 0) {
        this.form.get('txtProductCode')?.setErrors({ 'productCodeDuplicate': true });
        this.loading = false;
        return;
      }
    } catch (error) {
      console.error('Final duplicate check failed:', error);
      this.loading = false;
      return;
    }
  }

  // Insert task
  let auth_token: string | null = null;
  try {
    auth_token = await this.TokenService.RefreshToken();
  } catch (tokenError) {
    console.error('Cannot get Refresh Token:', tokenError);
    this.loading = false;
    return;
  }

  if (!auth_token) {
    console.error('Authentication Token not found');
    this.loading = false;
    return;
  }

  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${auth_token}`
    })
  };

  const objectjson: any = {
    ProductCode: this.form.get('txtProductCode')?.value?.trim(),
    ProductName: this.form.get('ProductName')?.value,
    ProductUOM: this.form.get('ProductUOM')?.value,
    ProductPrice: this.form.get('ProductPrice')?.value,
    ProductBV: this.form.get('ProductBV')?.value,
    ProductVat: this.form.get('ProductVat')?.value,
    ProductUseVatFlag: this.form.get('ProductUseVatFlag')?.value,
    ProductCategory: this.form.get('ProductCategory')?.value,
    ProductType: this.form.get('ProductType')?.value,
    ProductLicensePlate: this.form.get('ProductLicensePlate')?.value,
    ProductChassisNo: this.form.get('ProductChassisNo')?.value,
    ProductSerialNo: this.form.get('ProductSerialNo')?.value,
    ProductDescription: this.form.get('ProductDescription')?.value,
    ProductCreateBy: this.checkUndefinedString(this._EmpCode)
  };

  try {
    await this.httpClient.post<ProductInfo[]>(
      this.baseurl + "Product/InsertProduct",
      JSON.stringify(objectjson),
      httpOptions
    ).toPromise();

    $('#ModalAddEditProduct').modal('hide');
    $('#ModalProductInsertUpdateComplete').modal('show');

    setTimeout(async () => {
      await this.LoadProductList("Y");
    }, 100);

  } catch (apiError) {
    console.error('Call Insert Product API UnSuccess:', apiError);
  } finally {
    this.loading = false;
  }
}

  // async checkDuplicateProductCode0(productCode: string): Promise<any[]> {
  // try {
  //   var auth_token = await this.TokenService.RefreshToken();
  //   if (!!auth_token) {
  //     const httpOptions = {
  //       headers: new HttpHeaders({
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${auth_token}`
  //       })
  //     };
      
  //     const result = await this.httpClient.post<any[]>(this.baseurl + "Product/GetProductList", 
  //       JSON.stringify({ ProductCode: productCode }), httpOptions
  //     ).toPromise();
      
  //     return result || [];
  //   }
  //   return [];
  // } catch (error) {
  //   console.error('Error checking duplicate:', error);
  //   return [];
  // }
  // }

  async checkDuplicateProductCode(productCode: string): Promise<any[]> {
  try {
    if (!productCode || productCode.trim().length === 0) {
      return [];
    }

    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      throw new Error('Cannot get authentication token');
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    const payload = { ProductCode: productCode.trim() };
    
    const result = await this.httpClient.post<any[]>(
      this.baseurl + "Product/GetProductList",
      JSON.stringify(payload),
      httpOptions
    ).toPromise();

    return result || [];
  } catch (error) {
    console.error('Error checking duplicate product code:', error);
    throw error; // ให้ validator จัดการ error
  }
}

  private markFormGroupTouched(formGroup: FormGroup) {
  Object.values(formGroup.controls).forEach(control => {
    control.markAsTouched();
    control.updateValueAndValidity();
  });
  }

  duplicateProductCodeValidator(): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    if (!control.value || control.value.trim().length === 0) {
      return of(null);
    }

    // ใช้ debounceTime เพื่อลดการเรียก API
    return of(control.value).pipe(
      debounceTime(300),
      switchMap(value => 
        from(this.checkDuplicateProductCode(value)).pipe(
          map((result: any[] | null) => {
            if (!result || result.length === 0) {
              return null; // No data duplicate
            }

            // Check edit on own ProductID
            const currentProductId = this.hidProductID;
            if (currentProductId) {
              const isDuplicateOfSelf = result.some(
                (product: any) => product.ProductID === currentProductId
              );
              
              if (isDuplicateOfSelf && result.length === 1) {
                return null; // แก้ไขข้อมูลตัวเอง
              }
            }

            return { 'productCodeDuplicate': true };
          }),
          catchError(error => {
            console.error('Product Code Validation Error:', error);
            return of({ 'serverError': true });
          })
        )
      )
    );
  };
}

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }

  onNumberInput(event: Event, controlName: string, formattedVarName: keyof this): void {
    const input = event.target as HTMLInputElement;
    let rawValue = input.value;

    // Delete all charactors except number and '.'(dot)
    const cleanValue = rawValue.replace(/[^0-9.]/g, '');

    const numericValue = parseFloat(cleanValue);
    const control = this.form.get(controlName);

    if (control) {
      if (!isNaN(numericValue) && cleanValue !== '') {
        // ใช้ patchValue กับค่า numeric จริงๆ เก็บไว้ใน form control
        control.patchValue(numericValue, { emitEvent: false });
      } else {
        // ล้างค่าใน form control ถ้า input ไม่ใช่ตัวเลข
        control.patchValue(null, { emitEvent: false });
      }
    }

    // update variable formatted to display input
    // use `this[formattedVarName as string]` access variable by dynamic
    // use `as string` help TypeScript can know the property from name by type string
    (this[formattedVarName as string] as string) = cleanValue;
  }

  onNumberBlur(controlName: string, formattedVarName: keyof this): void {
    const control = this.form.get(controlName);
    if (!control) return;

    const numericValue = control.value; // ดึงค่าจาก form control

    // use formatPrice by original format
    // use `this[formattedVarName as string]` To access variables by dynamic control
    (this[formattedVarName as string] as string) = this.formatPrice(numericValue);
  }

  formatPrice(value: number | string): string {
    if (value == null || value === '') return '';
      const num = +value;
        return num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  btnClick_onUpdateProduct(id) {
    this.form.reset();
    $('#ModalAddEditProduct').modal('hide');
    this.isOnUpdateProduct = true;

    const product = this.ProductList.find(x => x.ProductID == id);
    this.hidProductID = product.ProductID;

    this.form.patchValue({
      txtProductCode: product.ProductCode || null,
      ProductName: product.ProductName || null,
      ProductUOM: product.ProductUOM || null,
      ProductPrice: product.ProductPrice || null,
      ProductBV: product.ProductBV || null,
      ProductVat: product.ProductVat || null,
      ProductUseVatFlag: product.ProductUseVatFlag || null,
      ProductCategory: product.ProductCategory || null,
      ProductType: product.ProductType || null,
      ProductLicensePlate: product.ProductLicensePlate || null,
      ProductChassisNo: product.ProductChassisNo || null,
      ProductSerialNo: product.ProductSerialNo || null,
      ProductDescription: product.ProductDescription || null
    });

    $('#ModalAddEditProduct').modal('show');
  }

  async btnClick_submitUpdateProduct() {
  this.loading = true;
  
  // wait async validation work finished
  await this.waitForAsyncValidation();
  
  if (!this.form.valid) {
    this.markFormGroupTouched(this.form);
    console.warn('Form not valid');
    this.loading = false;
    return;
  }

  // Check duplicate again submit (before update)
  const productCode = this.form.get('txtProductCode')?.value;
  if (productCode) {
    try {
      const duplicates = await this.checkDuplicateProductCode(productCode);
      if (duplicates && duplicates.length > 0) {
        const isDuplicateOfSelf = duplicates.some(
          (product: any) => product.ProductID === this.hidProductID
        );
        
        if (!isDuplicateOfSelf || duplicates.length > 1) {
          this.form.get('txtProductCode')?.setErrors({ 'productCodeDuplicate': true });
          this.loading = false;
          return;
        }
      }
    } catch (error) {
      console.error('Final duplicate check failed:', error);
      this.loading = false;
      return;
    }
  }

  // Update task
  let auth_token: string | null = null;
  try {
    auth_token = await this.TokenService.RefreshToken();
  } catch (tokenError) {
    console.error('Cannot get Refresh Token:', tokenError);
    this.loading = false;
    return;
  }

  if (!auth_token) {
    console.error('Authentication Token not found');
    this.loading = false;
    return;
  }

  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${auth_token}`
    })
  };

  const objectjson: any = {
    ProductID: this.hidProductID,
    ProductCode: this.form.get('txtProductCode')?.value?.trim(),
    ProductName: this.form.get('ProductName')?.value,
    ProductUOM: this.form.get('ProductUOM')?.value,
    ProductPrice: this.form.get('ProductPrice')?.value,
    ProductBV: this.form.get('ProductBV')?.value,
    ProductVat: this.form.get('ProductVat')?.value,
    ProductUseVatFlag: this.form.get('ProductUseVatFlag')?.value,
    ProductCategory: this.form.get('ProductCategory')?.value,
    ProductType: this.form.get('ProductType')?.value,
    ProductLicensePlate: this.form.get('ProductLicensePlate')?.value,
    ProductChassisNo: this.form.get('ProductChassisNo')?.value,
    ProductSerialNo: this.form.get('ProductSerialNo')?.value,
    ProductDescription: this.form.get('ProductDescription')?.value,
    ProductUpdateBy: this.checkUndefinedString(this._EmpCode)
  };

  try {
    await this.httpClient.post<ProductInfo[]>(
      this.baseurl + "Product/UpdateProduct",
      JSON.stringify(objectjson),
      httpOptions
    ).toPromise();

    $('#ModalAddEditProduct').modal('hide');
    $('#ModalProductInsertUpdateComplete').modal('show');

    setTimeout(async () => {
      await this.LoadProductList("Y");
    }, 100);

  } catch (apiError) {
    console.error('Call Update Product API UnSuccess:', apiError);
  } finally {
    this.loading = false;
  }
}

  async btnClick_onDeleteProductList() {
    if (confirm("Are you sure to delete this Product?")) {
  
      var checkkedproduct = $('[name="checkboxproduct"]:checked');
      let num = checkkedproduct.length;
      let listProductModel = [];
        
  
      for (var i = 0; i < num; i++) {
        var Productcurrent = <HTMLInputElement>checkkedproduct[i];
        let productInfo = new ProductInfo;
        productInfo.ProductID = parseInt(Productcurrent.value); //companycontactInfo
  
          var currentProduct = this.ProductList.filter(x => { return x.ProductID == productInfo.ProductID });
          var isOwner = (currentProduct[0].ProductCreateBy == this._EmpCode);
  
          //console.log(" Delete id = " + productInfo.ProductID + " \n Role = " + this._RoleCode + " \n Is Owner? = " + isOwner);
          if (isOwner || (this._RoleCode !== null && this._RoleCode !== "")) {
            listProductModel.push(productInfo);
            } else
          {
            //this.titlemodal = ""
            //this.detailmodal = "Cannot delete company : <b>" + currentCompany[0].CompanyName + "</b>. please contact " + currentCompany[0].CompanyCreateByDisplay;
            this.detailmodal = "You don't have permission to delete this company. Please contact" + currentProduct[0].ProductCreateBy;
            $('#ModalError .modal-header').text("Information");
            $('#ModalError .modal-header').addClass('bg-blue');
            $('#ModalError').modal();
  
            listProductModel = [];
            break; //break loop
          }
        }
  
        if (listProductModel.length > 0) {
          this.deleteProductList(listProductModel)
        }
  
      }
  }

  async deleteProductList(listProductModel) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Send to delete
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
          })
        };
       
  
        let strjsonCompGroupInfo = JSON.stringify(listProductModel);
        console.log('strjsonCompGroupInfo', strjsonCompGroupInfo)
  
        this.httpClient.post<ProductInfo[]>(this.baseurl + "Product/DeleteListProduct", strjsonCompGroupInfo, httpOptions)
          .toPromise()
          .then(data => {
            console.log("delete product list successfully");
            $('#ModalDeleteProductComplete').modal('show');
            this.onModalClose();
            this.LoadProductList("Y");
          })
          .catch(err => {
            console.log(err);
          });
      }
    }

  chkallProductclick(target) {
    var check = $(target.currentTarget).is(":checked");

    $('[name="checkboxproduct"]').prop('checked', check);

  }

  onModalClose() {
  if (this.chkAllProduct) {
    this.chkAllProduct.nativeElement.checked = false;
    }
  if (this.chkAllProduct) {
    this.chkAllProduct.nativeElement.checked = false;
    }
  }

  private async waitForAsyncValidation(): Promise<void> {
  return new Promise((resolve) => {
    const control = this.form.get('txtProductCode');
    if (control?.pending) {
      const subscription = control.statusChanges.subscribe(status => {
        if (status !== 'PENDING') {
          subscription.unsubscribe();
          resolve();
        }
      });
    } else {
      resolve();
    }
  });
}
}
